import React from "react";
import tw, { css, styled } from "twin.macro";

import heroImageSrc from "../../assets/images/features/hero-custom-branding.svg";
import Faqs from "../../components/common/Faqs";
import FooterCta from "../../components/common/FooterCta";
import { SectionColor } from "../../components/common/Section";
import SEO from "../../components/common/SEO";
import SvgObject from "../../components/elements/SvgObject";
import CustomBrandingFlow from "../../components/features/CustomBrandingFlow";
import ExploreOtherFeatures from "../../components/features/ExploreOtherFeatures";
import Hero, {
  HeroHeadline,
  HeroHeadlineHighlight,
  HeroSplitLeft,
  HeroSplitRight,
  HeroSubheadline,
} from "../../components/hero/Hero";
import HeroCta from "../../components/hero/HeroCta";
import HootsuiteTestimonialDark from "../../components/testimonials/HootsuiteTestimonialDark";
import GrowthResources from "../../components/tips/GrowthResources";
import TipCancellationFlowExamples from "../../components/tips/TipCancellationFlowExamples";
import TipChurnStakeholders from "../../components/tips/TipChurnStakeholders";
import TipCustomerRetentionExamplesTopCompanies from "../../components/tips/TipCustomerRetentionExamplesTopCompanies";
import LayoutDefault from "../../layouts/LayoutDefault";

const HeroImageProps = {
  data: heroImageSrc,
  width: 650,
  height: 513,
};

const CustomBrandingPage: React.FunctionComponent = () => (
  <LayoutDefault>
    <SEO
      title="Seamless, Custom-Branded Cancellation Flows"
      description="Save more customers with a custom-branded cancellation experience that looks as awesome as your site."
    />

    <Hero>
      <HeroSplitLeft fullWidth={570}>
        <HeroHeadline>
          <HeroHeadlineHighlight>Custom branding</HeroHeadlineHighlight> that
          looks as awesome as your site
        </HeroHeadline>
        <HeroSubheadline>
          The perfect cancellation experience is possible. ProsperStack makes it
          easy.
        </HeroSubheadline>
        <HeroCta />
      </HeroSplitLeft>
      <HeroSplitRight>
        <SvgObject
          {...HeroImageProps}
          tw="w-[80%]"
          css={css`
            transform: scale(1.35) translate(2.5%, -2%);
          `}
        />
      </HeroSplitRight>
    </Hero>

    <HootsuiteTestimonialDark />

    <CustomBrandingFlow />

    <Faqs
      title={<>Custom branding</>}
      questions={[
        {
          question: "Which ProsperStack plans include custom CSS?",
          answer: (
            <>
              Prosper and Enterprise plans include custom CSS features. Or speak
              to our sales team for other options.
            </>
          ),
        },
        {
          question: "Do I have to use custom CSS to brand my cancel flow?",
          answer: (
            <>No! You can add your logo to any cancel flow, even without CSS.</>
          ),
        },
      ]}
    />

    <ExploreOtherFeatures current="customBranding" color={SectionColor.Gray} />

    <GrowthResources>
      <TipCancellationFlowExamples />
      <TipCustomerRetentionExamplesTopCompanies />
      <TipChurnStakeholders />
    </GrowthResources>

    <FooterCta />
  </LayoutDefault>
);

export default CustomBrandingPage;
